import $ from 'jquery';
import SearchModuleUtil from '@lts-web/utils/SearchModuleUtil';

$.ModuleUtil = SearchModuleUtil.findSearchModule;
$.ModuleUtil.createSearchModuleData = SearchModuleUtil.createSearchModuleData;
$.ModuleUtil.getModule = SearchModuleUtil.getModule;
$.ModuleUtil.hasModule = SearchModuleUtil.hasModule;
$.ModuleUtil.getCurrentModule = SearchModuleUtil.getCurrentModule;
$.ModuleUtil.hasModuleName = SearchModuleUtil.hasModuleName;
$.ModuleUtil.pushSupportedModule = SearchModuleUtil.pushSupportedModule;
$.ModuleUtil.getSupportedModules = SearchModuleUtil.getSupportedModules;
$.ModuleUtil.getCurrentModuleName = SearchModuleUtil.getCurrentModuleName;
$.ModuleUtil.convertModule = SearchModuleUtil.convertModule;
$.ModuleUtil.calculateModule = () => SearchModuleUtil.calculateModule();
$.ModuleUtil.setModuleNameGetter = (getterFunction) => {
    if (typeof getterFunction !== 'function') {
        throw new TypeError('First argument must be of type `Function`');
    }

    SearchModuleUtil.currModuleNameGetter = getterFunction;
};

SearchModuleUtil.currModuleNameGetter = function () {
    if(!pageModuleInstance.isCMSPage())
        return $("#currentModule").val();

    if (isMobile === true) {
        var moduleBtnName = $('input[name="isHotel"]:checked').val(),
            moduleRadioType = $('input[name="whereRadio"]:checked').val();

        return moduleBtnName !== 'searchCar' && moduleBtnName !== 'orgTour' ? moduleRadioType + moduleBtnName : moduleBtnName;
    }

    var location = $(".whereToGo").filter(":checked").val();

    if (!location)
        return null;

    if (location.indexOf("isra") !== -1){
        return location+$("input[name='internal-hotel-include']").filter(":checked").val();
    }else{
        var moduleExt = $("input[name='external-hotel-include']").filter(":checked").val();
        location = moduleExt !== 'searchCar' && moduleBtnName !== 'orgTour' ? location  : '';
        return location+moduleExt;
    }
};